"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectProduct = exports.saveProduct = exports.getProductsList = exports.getProducts = exports.deleteProduct = exports.createProduct = exports.consolidateProducts = exports.SELECT_PRODUCT_SUCCESS = exports.SELECT_PRODUCT_REQUEST = exports.SELECT_PRODUCT_FAILURE = exports.SAVE_PRODUCT_SUCCESS = exports.SAVE_PRODUCT_REQUEST = exports.SAVE_PRODUCT_FAILURE = exports.GET_PRODUCTS_SUCCESS = exports.GET_PRODUCTS_REQUEST = exports.GET_PRODUCTS_LIST_SUCCESS = exports.GET_PRODUCTS_LIST_REQUEST = exports.GET_PRODUCTS_LIST_FAILURE = exports.GET_PRODUCTS_FAILURE = exports.DELETE_PRODUCT_SUCCESS = exports.DELETE_PRODUCT_REQUEST = exports.DELETE_PRODUCT_FAILURE = exports.CREATE_PRODUCT_SUCCESS = exports.CREATE_PRODUCT_REQUEST = exports.CREATE_PRODUCT_FAILURE = exports.CONSOLIDATE_PRODUCTS_SUCCESS = exports.CONSOLIDATE_PRODUCTS_REQUEST = exports.CONSOLIDATE_PRODUCTS_FAILURE = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _api = require("../middleware/api");
var _vendors = require("./vendors.actions");
var GET_PRODUCTS_REQUEST = exports.GET_PRODUCTS_REQUEST = 'GET_PRODUCTS_REQUEST';
var GET_PRODUCTS_SUCCESS = exports.GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
var GET_PRODUCTS_FAILURE = exports.GET_PRODUCTS_FAILURE = 'GET_PRODUCTS_FAILURE';
var GET_PRODUCTS_LIST_REQUEST = exports.GET_PRODUCTS_LIST_REQUEST = 'GET_PRODUCTS_LIST_REQUEST';
var GET_PRODUCTS_LIST_SUCCESS = exports.GET_PRODUCTS_LIST_SUCCESS = 'GET_PRODUCTS_LIST_SUCCESS';
var GET_PRODUCTS_LIST_FAILURE = exports.GET_PRODUCTS_LIST_FAILURE = 'GET_PRODUCTS_LIST_FAILURE';
var SELECT_PRODUCT_REQUEST = exports.SELECT_PRODUCT_REQUEST = 'SELECT_PRODUCT_REQUEST';
var SELECT_PRODUCT_SUCCESS = exports.SELECT_PRODUCT_SUCCESS = 'SELECT_PRODUCT_SUCCESS';
var SELECT_PRODUCT_FAILURE = exports.SELECT_PRODUCT_FAILURE = 'SELECT_PRODUCT_FAILURE';
var CREATE_PRODUCT_REQUEST = exports.CREATE_PRODUCT_REQUEST = 'CREATE_PRODUCT_REQUEST';
var CREATE_PRODUCT_SUCCESS = exports.CREATE_PRODUCT_SUCCESS = 'CREATE_PRODUCT_SUCCESS';
var CREATE_PRODUCT_FAILURE = exports.CREATE_PRODUCT_FAILURE = 'CREATE_PRODUCT_FAILURE';
var SAVE_PRODUCT_REQUEST = exports.SAVE_PRODUCT_REQUEST = 'SAVE_PRODUCT_REQUEST';
var SAVE_PRODUCT_SUCCESS = exports.SAVE_PRODUCT_SUCCESS = 'SAVE_PRODUCT_SUCCESS';
var SAVE_PRODUCT_FAILURE = exports.SAVE_PRODUCT_FAILURE = 'SAVE_PRODUCT_FAILURE';
var DELETE_PRODUCT_REQUEST = exports.DELETE_PRODUCT_REQUEST = 'DELETE_PRODUCT_REQUEST';
var DELETE_PRODUCT_SUCCESS = exports.DELETE_PRODUCT_SUCCESS = 'DELETE_PRODUCT_SUCCESS';
var DELETE_PRODUCT_FAILURE = exports.DELETE_PRODUCT_FAILURE = 'DELETE_PRODUCT_FAILURE';
var CONSOLIDATE_PRODUCTS_REQUEST = exports.CONSOLIDATE_PRODUCTS_REQUEST = 'CONSOLIDATE_PRODUCTS_REQUEST';
var CONSOLIDATE_PRODUCTS_SUCCESS = exports.CONSOLIDATE_PRODUCTS_SUCCESS = 'CONSOLIDATE_PRODUCTS_SUCCESS';
var CONSOLIDATE_PRODUCTS_FAILURE = exports.CONSOLIDATE_PRODUCTS_FAILURE = 'CONSOLIDATE_PRODUCTS_SUCCESS';
var getProducts = exports.getProducts = function getProducts() {
  var queryString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [GET_PRODUCTS_REQUEST, GET_PRODUCTS_SUCCESS, GET_PRODUCTS_FAILURE],
    authenticated: true,
    endpoint: "products".concat(queryString.length > 0 ? "?".concat(queryString) : ''),
    method: 'GET'
  });
};
var getProductsList = exports.getProductsList = function getProductsList() {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [GET_PRODUCTS_LIST_REQUEST, GET_PRODUCTS_LIST_SUCCESS, GET_PRODUCTS_LIST_FAILURE],
    authenticated: true,
    endpoint: 'products/list',
    method: 'GET'
  });
};
var selectProduct = exports.selectProduct = function selectProduct(productID) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [SELECT_PRODUCT_REQUEST, SELECT_PRODUCT_SUCCESS, SELECT_PRODUCT_FAILURE],
    authenticated: true,
    endpoint: "products/".concat(productID),
    method: 'GET'
  });
};
var createProduct = exports.createProduct = function createProduct(data) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [CREATE_PRODUCT_REQUEST, CREATE_PRODUCT_SUCCESS, CREATE_PRODUCT_FAILURE],
    authenticated: true,
    endpoint: "products",
    method: 'POST',
    payload: data
  });
};
var saveProduct = exports.saveProduct = function saveProduct(productID, data) {
  return /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(dispatch, getState) {
      var response;
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return dispatch(saveProductRequest(productID, data));
          case 1:
            response = _context.sent;
            if (!(response.type === 'SAVE_PRODUCT_FAILURE')) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", response);
          case 2:
            _context.next = 3;
            return dispatch((0, _vendors.getVendorProducts)(getState().vendors.get('vendor').vendorID));
          case 3:
            return _context.abrupt("return", dispatch(selectProduct(getState().products.get('product').productID)));
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var saveProductRequest = function saveProductRequest(productID, data) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [SAVE_PRODUCT_REQUEST, SAVE_PRODUCT_SUCCESS, SAVE_PRODUCT_FAILURE],
    authenticated: true,
    endpoint: "products/".concat(productID),
    method: 'PUT',
    payload: data
  });
};
var consolidateProducts = exports.consolidateProducts = function consolidateProducts(productID, data) {
  return /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(dispatch, getState) {
      return _regenerator["default"].wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return dispatch(consolidateProductsRequest(productID, data));
          case 1:
            _context2.next = 2;
            return dispatch((0, _vendors.getVendorProducts)(getState().vendors.get('vendor').vendorID));
          case 2:
            return _context2.abrupt("return", dispatch(selectProduct(getState().products.get('product').productID)));
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var consolidateProductsRequest = function consolidateProductsRequest(productID, data) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [CONSOLIDATE_PRODUCTS_REQUEST, CONSOLIDATE_PRODUCTS_SUCCESS, CONSOLIDATE_PRODUCTS_FAILURE],
    authenticated: true,
    endpoint: "products/".concat(productID, "/productConsolidation"),
    method: 'POST',
    payload: data
  });
};
var deleteProduct = exports.deleteProduct = function deleteProduct(productID) {
  return /*#__PURE__*/function () {
    var _ref9 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(dispatch, getState) {
      return _regenerator["default"].wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 1;
            return dispatch(deleteProductRequest(productID));
          case 1:
            _context3.next = 2;
            return dispatch((0, _vendors.getVendorProducts)(getState().vendors.get('vendor').vendorID));
          case 2:
            return _context3.abrupt("return", dispatch(selectProduct(getState().products.get('product').productID)));
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x5, _x6) {
      return _ref9.apply(this, arguments);
    };
  }();
};
var deleteProductRequest = function deleteProductRequest(productID) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [DELETE_PRODUCT_REQUEST, DELETE_PRODUCT_SUCCESS, DELETE_PRODUCT_FAILURE],
    authenticated: true,
    endpoint: "products/".concat(productID),
    method: 'DELETE'
  });
};